import { render, staticRenderFns } from "./CarouselProducts.vue?vue&type=template&id=90121c0c"
import script from "./CarouselProducts.vue?vue&type=script&lang=js"
export * from "./CarouselProducts.vue?vue&type=script&lang=js"
import style0 from "./CarouselProducts.vue?vue&type=style&index=0&id=90121c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports